import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

function Partnership() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          padding: '96px 0px',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { md: '64px', xs: '48px' },
          alignSelf: 'stretch',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: { xs: '100%', md: '1280px' },
            padding: { xs: '0 16px', md: '0px 32px' },
            boxSizing: 'border-box',
            flexDirection: 'column',
            alignItems: 'flex-start',
            boxSizing: 'border-box',
            gap: '32px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '12px',
              alignSelf: 'stretch',
            }}
          >
            <Typography
              sx={{
                color: '#4F9CF9',
                padding: '4px 12px',
                background: 'rgba(167, 206, 252, 0.20)',
                borderRadius: '16px',
                /* Text md/Semibold */
                fontFamily: 'Inter',
                fontSize: { xs: '14px', md: '16px'},
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: {xs: '20px', md: '24px'} /* 150% */,
                alignSelf: { xs: 'center', md: 'flex-start' },
              }}
            >
              How it goes
            </Typography>
            <Box
              sx={{
                display: 'flex',
                width: { xs: '100%', md: '768px' },
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '20px',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Typography
                sx={{
                  color: 'var(--Gray-900, #101828)',

                  /* Text md/Semibold */
                  fontFamily: 'Inter',
                  fontSize: { xs: '30px', md: '36px' },
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: { xs: '38px', md: '44px' } /* 122.222% */,
                  letterSpacing: '-0.72px',
                }}
              >
                Our Partnership Journey
              </Typography>
              {!matches && (
                <Typography
                  sx={{
                    color: 'var(--Gray-600, #475467)',

                    /* Text md/Semibold */
                    fontFamily: 'Inter',
                    fontSize: { xs: '18px', md: '20px' },
                    fontStyle: 'normal',
                    fontWeight: '400',
                    lineHeight: { xs: '24px', md: '30px' } /* 150% */,
                  }}
                >
                  We follow following steps to get our partners onboarded in
                  Ezaix
                </Typography>
              )}
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            width: { xs: '100%', md: '1280px' },
            padding: { xs: '0 16px', md: '0px 32px' },
            boxSizing: 'border-box',
            // flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: { xs: '20px', md: '24px' },
              gap: { xs: '48px', md: '64px' },
              alignSelf: 'stretch',
              background: 'var(--Gray-50, #F9FAFB)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                padding: '12px',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                background: 'var(--Primary-Buttons, #4F9CF9)',
              }}
            >
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  flexShrink: '0',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <mask
                    id="mask0_82_9460"
                    //   style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_82_9460)">
                    <path
                      d="M8.0719 16.9462H12.9822C13.2656 16.9462 13.5031 16.8504 13.6947 16.6587C13.8864 16.4671 13.9822 16.2296 13.9822 15.9462C13.9822 15.6629 13.8864 15.4254 13.6947 15.2337C13.5031 15.0421 13.2656 14.9462 12.9822 14.9462H8.0719C7.78857 14.9462 7.55107 15.0421 7.3594 15.2337C7.16773 15.4254 7.0719 15.6629 7.0719 15.9462C7.0719 16.2296 7.16773 16.4671 7.3594 16.6587C7.55107 16.8504 7.78857 16.9462 8.0719 16.9462ZM8.0719 13.0179H15.9284C16.2117 13.0179 16.4492 12.9221 16.6409 12.7304C16.8326 12.5388 16.9284 12.3013 16.9284 12.0179C16.9284 11.7346 16.8326 11.4971 16.6409 11.3054C16.4492 11.1138 16.2117 11.0179 15.9284 11.0179H8.0719C7.78857 11.0179 7.55107 11.1138 7.3594 11.3054C7.16773 11.4971 7.0719 11.7346 7.0719 12.0179C7.0719 12.3013 7.16773 12.5388 7.3594 12.7304C7.55107 12.9221 7.78857 13.0179 8.0719 13.0179ZM8.0719 9.0897H15.9284C16.2117 9.0897 16.4492 8.99386 16.6409 8.8022C16.8326 8.61053 16.9284 8.37303 16.9284 8.0897C16.9284 7.80636 16.8326 7.56886 16.6409 7.3772C16.4492 7.18553 16.2117 7.0897 15.9284 7.0897H8.0719C7.78857 7.0897 7.55107 7.18553 7.3594 7.3772C7.16773 7.56886 7.0719 7.80636 7.0719 8.0897C7.0719 8.37303 7.16773 8.61053 7.3594 8.8022C7.55107 8.99386 7.78857 9.0897 8.0719 9.0897ZM5.0719 18.9462H18.9284V5.0897H5.0719V18.9462ZM5.0719 21.2212C4.44627 21.2212 3.91069 20.9985 3.46517 20.5529C3.01964 20.1074 2.79688 19.5718 2.79688 18.9462V5.0897C2.79688 4.46406 3.01964 3.92849 3.46517 3.48297C3.91069 3.03746 4.44627 2.8147 5.0719 2.8147H9.0746C9.31917 2.20673 9.70558 1.72141 10.2339 1.35872C10.7621 0.996039 11.3509 0.814697 12.0001 0.814697C12.6494 0.814697 13.2382 0.996039 13.7664 1.35872C14.2947 1.72141 14.6811 2.20673 14.9257 2.8147H18.9284C19.554 2.8147 20.0896 3.03746 20.5351 3.48297C20.9807 3.92849 21.2034 4.46406 21.2034 5.0897V18.9462C21.2034 19.5718 20.9807 20.1074 20.5351 20.5529C20.0896 20.9985 19.554 21.2212 18.9284 21.2212H5.0719ZM12.0001 4.31577C12.2306 4.31577 12.4212 4.24042 12.5719 4.08972C12.7226 3.93902 12.798 3.74843 12.798 3.51795C12.798 3.28746 12.7226 3.09687 12.5719 2.94617C12.4212 2.79547 12.2306 2.72012 12.0001 2.72012C11.7697 2.72012 11.5791 2.79547 11.4284 2.94617C11.2777 3.09687 11.2023 3.28746 11.2023 3.51795C11.2023 3.74843 11.2777 3.93902 11.4284 4.08972C11.5791 4.24042 11.7697 4.31577 12.0001 4.31577Z"
                      fill="white"
                    />
                  </g>
                </svg>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: { xs: '4px', md: '8px' },
                flex: '1 0 0',
                alignSelf: 'stretch',
                background: 'var(--Gray-50, #F9FAFB)',
              }}
            >
              <Typography
                sx={{
                  color: 'var(--Gray-900, #101828)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: { xs: '18px', md: '20px' },
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: { xs: '24px', md: '30px' } /* 150% */,
                }}
              >
                Step 1: Discovery and Assessment
              </Typography>
              <Typography
                sx={{
                  color: 'var(--Gray-600, #475467)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px' /* 150% */,
                }}
              >
                Understanding your unique needs and challenges is our first
                step. Through comprehensive discussions, we aim to grasp your
                business goals and how we can align our solutions for maximum
                impact.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: { xs: '20px', md: '24px' },
              gap: { xs: '48px', md: '64px' },
              alignSelf: 'stretch',
              background: 'var(--Gray-50, #F9FAFB)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                padding: '12px',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                background: 'var(--Primary-Buttons, #4F9CF9)',
              }}
            >
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  flexShrink: '0',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V13M12 8H16V12M15.5 3.5V2M19.4393 4.56066L20.5 3.5M20.5103 8.5H22.0103M3 13.3471C3.65194 13.4478 4.31987 13.5 5 13.5C9.38636 13.5 13.2653 11.3276 15.6197 8"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: { xs: '4px', md: '8px' },
                flex: '1 0 0',
                alignSelf: 'stretch',
                background: 'var(--Gray-50, #F9FAFB)',
              }}
            >
              <Typography
                sx={{
                  color: 'var(--Gray-900, #101828)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: { xs: '18px', md: '20px' },
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: { xs: '24px', md: '30px' } /* 150% */,
                }}
              >
                Step 2: Tailored Solution Development{' '}
              </Typography>
              <Typography
                sx={{
                  color: 'var(--Gray-600, #475467)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px' /* 150% */,
                }}
              >
                Leveraging our technological expertise, we craft customized
                solutions that integrate seamlessly into your existing
                processes, ensuring they meet your specific operational needs.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: { xs: '20px', md: '24px' },
              gap: { xs: '48px', md: '64px' },
              alignSelf: 'stretch',
              background: 'var(--Gray-50, #F9FAFB)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                padding: '12px',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                background: 'var(--Primary-Buttons, #4F9CF9)',
              }}
            >
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  flexShrink: '0',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.99962 14C8.99962 14 10.3121 15.5 12.4996 15.5C14.6871 15.5 15.9996 14 15.9996 14M15.2496 9H15.2596M9.74962 9H9.75962M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20ZM15.7496 9C15.7496 9.27614 15.5258 9.5 15.2496 9.5C14.9735 9.5 14.7496 9.27614 14.7496 9C14.7496 8.72386 14.9735 8.5 15.2496 8.5C15.5258 8.5 15.7496 8.72386 15.7496 9ZM10.2496 9C10.2496 9.27614 10.0258 9.5 9.74962 9.5C9.47348 9.5 9.24962 9.27614 9.24962 9C9.24962 8.72386 9.47348 8.5 9.74962 8.5C10.0258 8.5 10.2496 8.72386 10.2496 9Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: { xs: '4px', md: '8px' },
                flex: '1 0 0',
                alignSelf: 'stretch',
                background: 'var(--Gray-50, #F9FAFB)',
              }}
            >
              <Typography
                sx={{
                  color: 'var(--Gray-900, #101828)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: { xs: '18px', md: '20px' },
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: { xs: '24px', md: '30px' } /* 150% */,
                }}
              >
                Step 3: Implementation and Support{' '}
              </Typography>
              <Typography
                sx={{
                  color: 'var(--Gray-600, #475467)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px' /* 150% */,
                }}
              >
                Our support doesn’t end with deployment. We ensure a smooth
                transition, followed by continuous assistance and optimization
                to keep your operations running at peak efficiency.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: { xs: '20px', md: '24px' },
              gap: { xs: '48px', md: '64px' },
              alignSelf: 'stretch',
              background: 'var(--Gray-50, #F9FAFB)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                padding: '12px',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                background: 'var(--Primary-Buttons, #4F9CF9)',
              }}
            >
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  flexShrink: '0',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12.9999 2L4.09332 12.6879C3.74451 13.1064 3.57011 13.3157 3.56744 13.4925C3.56512 13.6461 3.63359 13.7923 3.75312 13.8889C3.89061 14 4.16304 14 4.7079 14H11.9999L10.9999 22L19.9064 11.3121C20.2552 10.8936 20.4296 10.6843 20.4323 10.5075C20.4346 10.3539 20.3661 10.2077 20.2466 10.1111C20.1091 10 19.8367 10 19.2918 10H11.9999L12.9999 2Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: { xs: '4px', md: '8px' },
                flex: '1 0 0',
                alignSelf: 'stretch',
                background: 'var(--Gray-50, #F9FAFB)',
              }}
            >
              <Typography
                sx={{
                  color: 'var(--Gray-900, #101828)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: { xs: '18px', md: '20px' },
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: { xs: '24px', md: '30px' } /* 150% */,
                }}
              >
                Step 4: Continuous Growth and Innovation{' '}
              </Typography>
              <Typography
                sx={{
                  color: 'var(--Gray-600, #475467)',

                  /* Text xl/Semibold */
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px' /* 150% */,
                }}
              >
                As partners, we're committed to your ongoing success. We
                continually seek ways to enhance our solutions and support your
                growth with the latest technological advancements.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Partnership;
